import React from 'react';

import { Svg, type SvgProps } from './svg';

export function EyeIcon(props: SvgProps) {
  return (
    <Svg data-testid="eye-icon" {...props}>
      <path d="M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7ZM10 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Z" />
      <path d="M12 4.75c-5.453 0-8.646 4.52-9.69 6.955a.75.75 0 0 0 .039.667C3.67 14.685 6.53 19.25 12 19.25s8.33-4.565 9.651-6.878a.75.75 0 0 0 .02-.707c-.527-1.055-1.577-2.763-3.164-4.218C16.915 5.987 14.742 4.75 12 4.75Zm0 13c-4.323 0-6.774-3.433-8.158-5.792C4.924 9.7 7.674 6.25 12 6.25c2.258 0 4.085 1.012 5.493 2.303 1.248 1.144 2.135 2.48 2.651 3.428C18.758 14.34 16.31 17.75 12 17.75Z" />
    </Svg>
  );
}
